import "./index.scss";
import Loader from "react-loaders";
import { useEffect, useRef, useState } from "react";
// import emailjs from "@emailjs/browser";
// import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import Telefon from "../../assets/images/Telefon.png";
import AnimatedLetters from "../AnimatedLetters";

const Contact = () => {
  const [letterClass, setLetterClass] = useState("text-animate");
  const form = useRef();

   const [formData, setFormData] = useState({ name: '', email: '',subject:'', message: '' });
  const [status, setStatus] = useState('');

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3000);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Submitting...');
    try {
      const response = await fetch('https://formspree.io/f/xeoqllvl', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        setStatus('Message sent successfully!');
        setFormData({ name: '', email: '', message: '' });
      } else {
        setStatus('Failed to send message. Try again.');
      }
    } catch (error) {
      setStatus('Error: Unable to connect to the server.');
    }
  };
  // const sendEmail = (e) => {
  //   e.preventDefault();

  //   emailjs
  //     .sendForm(
  //       "service_tifdfl9",
  //       "template_tcpr3kj",
  //       form.current,
  //       "YNBcu9d1NSNt_rat7"
  //     )
  //     .then(
  //       () => {
  //         alert("Message successfully sent!");
  //         form.current.reset();
  //       },
  //       (e) => {
  //         console.log(e)
  //         alert("Failed to send the message, please try again");
  //       }
  //     );
  // };
  // https://www.emailjs.com/docs/tutorial/creating-contact-form/
  // https://dashboard.emailjs.com/admin
  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={["C", "o", "n", "t", "a", "c", "t", " ", "m", "e."]}
              idx={15}
            />
          </h1>
          <p>
            I am interested in both freelancing and employment opportunities -
            especially on ambitious or large projects. However, if you have any
            other requests or questions, don't hesitate to contact me using
            below form either.
          </p>
          <div className="contact-form">
            <form ref={form} onSubmit={handleSubmit}>
              <ul>
                <li className="half">
                  <input
                    placeholder="Your Name"
                    type="text"
                    name="name"
                     onChange={handleChange}
                    value={formData.name}
                    required
                  />
                </li>
                <li className="half">
                  <input
                    placeholder="Your Email"
                    type="email"
                    name="email"
                    onChange={handleChange}
                    value={formData.email}
                    required
                  />
                </li>
                <li>
                  <input
                    placeholder="Subject"
                    type="text"
                    name="subject"
                    onChange={handleChange}
                    value={formData.subject}
                    required
                  />
                </li>
                <li>
                  <textarea
                    placeholder="Your Message..."
                    name="message"
                    onChange={handleChange}
                    value={formData.message}
                    required
                  ></textarea>
                </li>
                <li>
                  <input type="submit" className="flat-button" value="SEND" />
                  {status && <p className={{marginTop: '1rem', fontSize: '1rem', color: 'green'}}>{status}</p>}
                </li>
              </ul>
            </form>
          </div>
        </div>
        <div className="fon-wrap">
          <img src={Telefon} alt="Telefon" className="telefonImg" />,
        </div>
      </div>
      <Loader type="pacman" />
    </>
  );
};
export default Contact;
